<template>
  <div class=" row no-wrap">
    <GroupList class="full-height self-strentch" style="width: 200px" />
    <GroupUserList class="full-height self-strentch" style="width: 500px" />
    <UserSampleList class="full-height self-strentch col-grow" />
  </div>
</template>

<script>
export default {
  components: {
    GroupList: () => import("./GroupList"),
    GroupUserList: () => import("./GroupUserList"),
    UserSampleList: () => import("./UserSampleList"),
  },
};
</script>
